/** @format */

import {Trans, useTranslation} from 'react-i18next';

import {ColumnType} from 'components/Table/core/types';

import {FormattedCell} from 'pages/Home/Main/Project/components/Campaigns/components/FormattedCell';

import {KPI_WIDTH} from '../constants';

const useGetColumns = (): ColumnType[] => {
  const {t} = useTranslation();

  const columns: ColumnType[] = [
    {
      id: 'title',
      title: <Trans>Название</Trans>,
      size: 300,
      sortingFn: 'text',
      order: 0,
    },
    {
      id: 'id',
      title: 'ID',
      size: 120,
      sortingFn: 'alphanumeric',
      order: 10,
    },
    {
      id: 'subAccount',
      title: <Trans>Субаккаунт</Trans>,
      size: 150,
      sortingFn: 'text',
      order: 20,
    },
    {
      id: 'mediaplanType',
      title: <Trans>Тип</Trans>,
      size: 120,
      sortingFn: 'text',
      order: 30,
    },
    {
      id: 'spent',
      title: `${t('Расход')}, \u20BD (${t('с НДС')})`,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 40,
      cell: FormattedCell,
    },
    {
      id: 'impressions',
      title: <Trans>Показы</Trans>,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 50,
      cell: FormattedCell,
    },
    {
      id: 'clicks',
      title: <Trans>Клики</Trans>,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 60,
      cell: FormattedCell,
    },
    {
      id: 'ctr',
      title: 'CTR, %',
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 70,
      cell: FormattedCell,
    },
    {
      id: 'cpc',
      title: 'CPC, \u20BD',
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 80,
      cell: FormattedCell,
    },
    {
      id: 'conversions',
      title: <Trans>Лиды</Trans>,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 90,
      cell: FormattedCell,
    },
    {
      id: 'cpl',
      title: 'CPL, \u20BD',
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 100,
      cell: FormattedCell,
    },
    {
      id: 'ePurchaseConversions',
      title: <Trans>Заказы</Trans>,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 110,
      cell: FormattedCell,
    },
    {
      id: 'revenue',
      title: `${t('Доход')}, \u20BD`,
      size: KPI_WIDTH,
      sortingFn: 'alphanumeric',
      order: 120,
      cell: FormattedCell,
    },
    {
      id: 'drr',
      title: 'ДРР, %',
      size: 100,
      sortingFn: 'alphanumeric',
      order: 130,
      cell: FormattedCell,
    },
  ];

  return columns;
};

export {useGetColumns};
